// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ehazzhswtowuskdmgibz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVoYXp6aHN3dG93dXNrZG1naWJ6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwNTEzNjgsImV4cCI6MjA2OTYyNzM2OH0.rBXFY5_AxHxVUiTxRO1y-21FftDe-gQStMajW8I6dJ4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});